import React from 'react';
import { Bell, Menu, Search, LogOut, User } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import { logout, selectCurrentUser } from '../redux/slices/auth.slice';
import { useNavigate } from 'react-router-dom';
import modalNotification from '../utils/notification';

const Header = ({ toggleSidebar }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector(selectCurrentUser);

  const handleLogout = () => {
    dispatch(logout());
    navigate('/');
    modalNotification({
      type: 'success',
      message: "Logout successfully!"
    })
  };

  return (
    <div className="header-top">
      <div className="header-left">
        <button className="menu-toggle-btn" onClick={toggleSidebar}>
          <Menu size={24} />
        </button>

        {/* <div className="search-container">
          <input 
            type="text" 
            placeholder="Search..." 
            className="search-input"
          />
          <div className="search-icon">
            <Search size={18} color="#6F767E" />
          </div>
        </div> */}
      </div>

      <div className="header-actions">
        <div className="notification-btn">
          <Bell size={20} color="#6F767E" />
          <div className="notification-dot"></div>
        </div>

        {/* User Profile & Logout Section */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginLeft: '12px', paddingLeft: '24px', borderLeft: '1px solid var(--border-color)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '40px', height: '40px', borderRadius: '12px', backgroundColor: 'var(--primary-orange-light, #FFEDD5)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--primary-orange, #F97316)' }}>
              <User size={20} />
            </div>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <span style={{ fontSize: '14px', fontWeight: '600', color: 'var(--text-main, #1A1D1F)' }}>
                {user?.first_name ? `${user.first_name} ${user.last_name || ''}` : 'Admin User'}
              </span>
              <span style={{ fontSize: '12px', color: 'var(--text-secondary, #6F767E)', textTransform: 'capitalize' }}>
                {user?.role || 'Administrator'}
              </span>
            </div>
          </div>

          <button
            onClick={handleLogout}
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: '8px',
              padding: '8px 16px',
              border: '1px solid #FCA5A5',
              borderRadius: '10px',
              backgroundColor: '#FEF2F2',
              cursor: 'pointer',
              color: '#DC2626',
              fontSize: '13px',
              fontWeight: '600',
              transition: 'all 0.2s ease',
              marginLeft: '8px'
            }}
            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = '#FEE2E2'; e.currentTarget.style.borderColor = '#F87171'; }}
            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = '#FEF2F2'; e.currentTarget.style.borderColor = '#FCA5A5'; }}
            title="Logout"
          >
            <LogOut size={16} />
            <span className="logout-text">Logout</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Header;
